import AppSidebar from "@/layouts/App/NavDrawer";
import AppToolbar from "@/layouts/App/Toolbar";
import AppFooter from "@/layouts/App/Footer";
// Pages
//import Dashboardv1 from "@/views/Dashboard/Dashboardv1";
import LoginPage from "@/views/Pages/Authentication/LoginPage";
import BlankPage from "@/views/BlankPage";
import PaymentsPage from "@/views/Pages/PaymentsPage";
import TransportsPage from "@/views/Pages/TransportsPage";
import ProfileView from "@/views/Pages/Profile";
import User from "@/views/Pages/User";
import Userslist from "@/views/Pages/UserslistPage";
import RentslistPage from "@/views/Pages/ListrentsPage";
import CobrarAdeudo from "@/views/Pages/CobrarAdeudoPage";
import MachinesList from "@/views/Pages/MachinesList";
import MachineDetailPage from "@/views/Pages/MachineDetailPage";
import MachineDetailEditPage from "@/views/Pages/MachineDetailEditPage";
import NewCustomer from "@/views/Pages/NewCustomerPage";
import CreateAutoRent from "@/views/Pages/CreateAutoRentPage";
import CreateAutoRent2 from "@/views/Pages/CreateAutoRent2";
import TransportDetailPage from "@/views/Pages/TransportDetailPage";
import PremiumListPage from "@/views/Pages/PremiumListPage";
import PremiumDetailPage from "@/views/Pages/PremiumDetailPage";
import DashboardPage from "@/views/Pages/Dashboard2Page";
import ExportsPage from "@/views/Pages/ExportsPage";
import MachinesRentsPage from "@/views/Pages/MachinesRentsPage";
import DemosList from "@/views/Pages/DemosList";

export const routes = [
  { path: "/", redirect: "/pages/authentication/login" },
  {
    path: "/blank-page",
    name: "BlankPage",
    components: {
      default: BlankPage,
      sidebar: AppSidebar,
      header: AppToolbar,
      footer: AppFooter
    }
  },
  {
    path: "/dashboard",
    name: "pages/DashboardPage",
    components: {
      default: DashboardPage,
      sidebar: AppSidebar,
      header: AppToolbar,
      footer: AppFooter
    }
  },
  {
    path: "/pages/authentication/login",
    components: { default: LoginPage },
    name: "pages/authentication/LoginPage",
    meta: { layout: "auth" }
  },
  {
    path: "/payments-page",
    name: "pages/PaymentsPage",
    components: {
      default: PaymentsPage,
      sidebar: AppSidebar,
      header: AppToolbar,
      footer: AppFooter
    }
  },
  {
    path: "/transports-page",
    name: "pages/TransportsPage",
    components: {
      default: TransportsPage,
      sidebar: AppSidebar,
      header: AppToolbar,
      footer: AppFooter
    }
  },
  {
    path: "/rents-page",
    name: "pages/RentsPage",
    components: {
      default: RentslistPage,
      sidebar: AppSidebar,
      header: AppToolbar,
      footer: AppFooter
    }
  },
  {
    path: "/dashboard/dashboardv1",
    name: "dashboard/Dashboardv1",
    components: {
      sidebar: AppSidebar,
      header: AppToolbar,
      footer: AppFooter
    }
  },
  {
    path: "/pages/profile",
    components: {
      default: ProfileView,
      sidebar: AppSidebar,
      header: AppToolbar,
      footer: AppFooter
    }
  },
  {
    path: "/pages/user/:id",
    components: {
      default: User,
      sidebar: AppSidebar,
      header: AppToolbar,
      footer: AppFooter
    },
    props: true,
    name: "pages/User"
  },
  {
    path: "/pages/userslist",
    components: {
      default: Userslist,
      sidebar: AppSidebar,
      header: AppToolbar,
      footer: AppFooter
    },
    name: "pages/Userslist"
  },
  {
    path: "/pages/createautorent",
    components: {
      default: CreateAutoRent,
      sidebar: AppSidebar,
      header: AppToolbar,
      footer: AppFooter
    },
    props: true,
    name: "pages/CreateAutoRent"
  },
  {
    path: "/pages/createautorent2",
    components: {
      default: CreateAutoRent2,
      sidebar: AppSidebar,
      header: AppToolbar,
      footer: AppFooter
    },
    props: true,
    name: "pages/CreateAutoRent2"
  },
  {
    path: "/pages/cobraradeudo",
    components: {
      default: CobrarAdeudo,
      sidebar: AppSidebar,
      header: AppToolbar,
      footer: AppFooter
    },
    name: "pages/CobrarAdeudo"
  },
  {
    path: "/pages/machineslist",
    components: {
      default: MachinesList,
      sidebar: AppSidebar,
      header: AppToolbar,
      footer: AppFooter
    },
    name: "pages/MachinesList"
  },
  {
    path: "/pages/machinedetail/:id",
    components: {
      default: MachineDetailPage,
      sidebar: AppSidebar,
      header: AppToolbar,
      footer: AppFooter
    },
    name: "pages/MachinesDetailPage"
  },
  {
    path: "/pages/demoslist",
    components: {
      default: DemosList,
      sidebar: AppSidebar,
      header: AppToolbar,
      footer: AppFooter
    },
    name: "pages/DemosList"
  },
  {
    path: "/pages/transportdetail/:id",
    components: {
      default: TransportDetailPage,
      sidebar: AppSidebar,
      header: AppToolbar,
      footer: AppFooter
    },
    name: "pages/TransportDetailPage"
  },
  {
    path: "/pages/machinedetailedit/:id",
    components: {
      default: MachineDetailEditPage,
      sidebar: AppSidebar,
      header: AppToolbar,
      footer: AppFooter
    },
    props: true,
    name: "pages/MachinesDetailEditPage"
  },
  {
    path: "/pages/newcustomer",
    components: {
      default: NewCustomer,
      sidebar: AppSidebar,
      header: AppToolbar,
      footer: AppFooter
    },
    name: "pages/NewCustomerPage"
  },
  {
    path: "/pages/premiumlist",
    components: {
      default: PremiumListPage,
      sidebar: AppSidebar,
      header: AppToolbar,
      footer: AppFooter
    },
    name: "pages/PremiumList"
  },
  {
    path: "/pages/premiumdetail",
    components: {
      default: PremiumDetailPage,
      sidebar: AppSidebar,
      header: AppToolbar,
      footer: AppFooter
    },
    props: true,
    name: "pages/PremiumDetail"
  },
  {
    path: "/pages/exports",
    components: {
      default: ExportsPage,
      sidebar: AppSidebar,
      header: AppToolbar,
      footer: AppFooter
    },
    name: "pages/ExportsPage"
  },
  {
    path: "/pages/machinesrents",
    components: {
      default: MachinesRentsPage,
      sidebar: AppSidebar,
      header: AppToolbar,
      footer: AppFooter
    },
    name: "pages/MachinesRentsPage"
  }
];
